import { cn } from "@/utils/theme";
import type { ItemsType } from "../../../types/entities/legal";

interface TabItemProps {
  item: ItemsType;
  isDisabled?: boolean;
}

export const TabItem = ({ item, isDisabled = false }: TabItemProps) => {
  const { isSelected, label, onClick } = item;

  const baseClasses =
    "text-base font-semibold text-center inline-block p-2 border-b-2 rounded-t-lg";

  const selectedClass = isSelected
    ? isDisabled
      ? "bg-neutral-object-accent-silent text-on-disabled"
      : "border-contextual-action text-action"
    : isDisabled
      ? "border-transparent text-on-disabled"
      : "border-transparent cursor-pointer text-body-loud hover:text-body hover:border-body dark:hover:text-body";

  return (
    <li>
      <button
        className={cn(baseClasses, selectedClass)}
        onClick={onClick}
        disabled={isDisabled}
      >
        {label}
      </button>
    </li>
  );
};
